@if (!isLoading) {
  <div class="container period-selection-container">
    <div class="row">
      <div class="col col-12">
        <p class="consolidate-periods-form-header">To estimate the missing period, select the existing statements to subtract from other existing statements</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-3">
        <label class="period-selection-label"></label>
      </div>
      <div class="col col-9">
        <div [class.is-invalid]="isFieldInvalid('periods')">
          <app-popover-menu-multi-select
            [multiSelectOptions]="multiSelectPeriodOptionsAddition"
            [buttonText]="multiSelectButtonTextAddition"
            (selectOrDeselectAll)="selectOrDeselectAllAddition()"
          ></app-popover-menu-multi-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-3">
        <label class="period-selection-label">(minus)<i class="fa-solid fa-minus"></i></label>
      </div>
      <div class="col col-9">
        <div [class.is-invalid]="isFieldInvalid('periods')">
          <app-popover-menu-multi-select
            [multiSelectOptions]="multiSelectPeriodOptionsSubtraction"
            [buttonText]="multiSelectButtonTextSubtraction"
            (selectOrDeselectAll)="selectOrDeselectAllSubtraction()"
          ></app-popover-menu-multi-select>
        </div>
        @if (isFieldInvalid('periods')) {
          <div class="invalid-feedback">
            Please select at least one period.
          </div>
        }
      </div>
    </div>
    <div class="row missing-period-date-label-row">
      <div class="col col-3"></div>
      <div class="col col-9 missing-period-date-col">
        <label class="missing-period-date-label">Missing Period Date</label>
      </div>
    </div>
    <div class="row">
      <div class="col col-3">
        <label class="period-selection-label">(equals)<i class="fa-solid fa-equals"></i></label>
      </div>
      <div class="col col-9">
        <div [class.is-invalid]="isFieldInvalid('statementDate')">
          <app-input-calendar-component
            [initialDate]="statementDate"
            (dateEmitter)="updateStatementDate($event)"
          ></app-input-calendar-component>
        </div>
        @if (isFieldInvalid('statementDate')) {
          <div class="invalid-feedback">
            Please set a missing period date.
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <p class="add-consolidated-period-information-text">Add calculated period information</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <label for="reportingIntervalSelect">Select Reporting Interval</label>
        <div [class.is-invalid]="isFieldInvalid('reportingInterval')">
          <app-select2
            id="reportingIntervalSelect"
            placeholder="Select"
            [data]="reportingIntervalOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="reportingInterval"
            (valueChanged)="updateReportingInterval($event.value)"
            [width]="'100%'"
            >
          </app-select2>
        </div>
        @if (isFieldInvalid('reportingInterval')) {
          <div class="invalid-feedback">
            Please select a reporting interval.
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col col-6 balance-sheet-select">
        <label for="balanceSheetFrameSelect">Select Balance Sheet Period</label>
        <div [class.is-invalid]="isFieldInvalid('balanceSheet')">
          <app-select2
            id="balanceSheetFrameSelect"
            placeholder="Select"
            [data]="periodOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="selectedBalanceSheetFrameIndex"
            (valueChanged)="updateSelectedBalanceSheetFrameIndex($event.value)"
            [width]="'100%'"
            >
          </app-select2>
        </div>
        @if (isFieldInvalid('balanceSheet')) {
          <div class="invalid-feedback">
            Please select a balance sheet period.
          </div>
        }
      </div>
      <div class= "col col-6 currency-select">
        <label for="currencySelect">Select Currency</label>
        <span class="ps-2">
          <i class="fas fa-circle-question" data-bs-toggle="tooltip" data-bs-placement="top"
            title="Use this to select the currency for this built statement. Note: Currencies will not be converted. If calculating missing
            periods across different currencies but choosing one currency (e.g., USD), amounts will be calculated without conversion."></i>
        </span>
        <select class="form-select" (change)="changeCurrency($event.target.value)">
          @for (currencyOption of supportedCurrencies; track currencyOption) {
            <option [value]="currencyOption.key"
              [selected]="currencyOption.key === currency">
              {{currencyOption.key}} ({{currencyOption.symbol}})
            </option>
          }
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col col-6 balance-sheet-select">
        <label for="scenarioTypeSelect">Scenario Type</label>
        <div [class.is-invalid]="isFieldInvalid('scenarioType')">
          <app-select2
            id="scenarioTypeSelect"
            placeholder="Select"
            [data]="scenarioTypeOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="scenarioType"
            (valueChanged)="updateScenarioType($event.value)"
            [width]="'100%'"
          ></app-select2>
        </div>
        @if (isFieldInvalid('scenarioType')) {
          <div class="invalid-feedback">Please select a scenario type.</div>
        }
      </div>
      <div class="col col-6 currency-select">
        <label for="scenarioNameInput">Scenario Name</label>
        <input
          id="scenarioNameInput"
          type="text"
          [class.is-invalid]="isFieldInvalid('scenarioName')"
          class="form-control"
          [(ngModel)]="scenarioName"
          (ngModelChange)="setIsFormComplete()"
          [disabled]="isScenarioNameDisabled"
          placeholder="Scenario Name"
        />
        @if (isFieldInvalid('scenarioName')) {
          <div class="invalid-feedback">{{ getScenarioNameError() }}</div>
        }
      </div>
    </div>
    @if (isBeginningCashInTable) {
      <div class="row">
        <div class="col col-12">
          <label for="beginningCashFrameSelect">Select Beginning Cash Period</label>
          <div [class.is-invalid]="isFieldInvalid('beginningCash')">
            <app-select2
              id="beginningCashFrameSelect"
              placeholder="Select"
              [data]="periodOptions"
              [options]="{minimumResultsForSearch: -1}"
              [value]="selectedBeginningCashFrameIndex"
              (valueChanged)="updateSelectedBeginningCashFrameIndex($event.value)"
              [width]="'100%'"
              >
            </app-select2>
          </div>
          @if (isFieldInvalid('beginningCash')) {
            <div class="invalid-feedback">
              Please select a beginning cash period.
            </div>
          }
        </div>
      </div>
    }
    @if (isEndingCashInTable) {
      <div class="row">
        <div class="col col-12">
          <label for="endingCashFrameSelect">Select Ending Cash Period</label>
          <div [class.is-invalid]="isFieldInvalid('endingCash')">
            <app-select2
              id="endingCashFrameSelect"
              placeholder="Select"
              [data]="periodOptions"
              [options]="{minimumResultsForSearch: -1}"
              [value]="selectedEndingCashFrameIndex"
              (valueChanged)="updateSelectedEndingCashFrameIndex($event.value)"
              [width]="'100%'"
              >
            </app-select2>
          </div>
          @if (isFieldInvalid('endingCash')) {
            <div class="invalid-feedback">
              Please select an ending cash period.
            </div>
          }
        </div>
      </div>
    }
    <div class="row footer">
      <div class="col col-12 footer-col">
        <div class="footer-content">
          <div class="error-message-container">
            @if (wasValidated && !isFormComplete) {
              <span class="validation-error-message">Please resolve error(s)</span>
            }
          </div>
          <div class="button-container">
            <button class="btn btn-link" (click)="triggerCloseMissingStatementForm()">Cancel</button>
            <button class="btn btn-primary" (click)="generateStatementForMissingPeriod()" [disabled]="isSubmitting">
              <span class="build-statement-btn-label">Build Statement</span>
              @if (isSubmitting) {
                <div class="loader button-loader build-statement-btn-icon"></div>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="loading-panel-container loader__container">
    <div class="loader"></div>
  </div>
}
